import { createFileRoute, Outlet } from "@tanstack/react-router";
import { BaselineSelector } from "@/components/admin/BaselineSelector";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <div>
      <div className="flex items-center justify-between border-b px-4 py-2">
        <span className="text-sm font-medium text-muted-foreground">Admin</span>
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">Baseline:</span>
          <BaselineSelector />
        </div>
      </div>
      <Outlet />
    </div>
  );
}
